module.exports = __webpack_public_path__ + "img/icon-search.6a666139.png";